import { useState } from "react";

import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

import {
  defaultKSK2130_R01Filter,
  useKSK2130_R01Store,
} from "./Store_KSK2130_R01";

export const SearchSection_KSK2130_R01 = () => {
  const { setCodeSearchModalProps } = useUiuxStore();
  const { KSK2130_R01Filter, setKSK2130_R01Filter } =
    useKSK2130_R01Store();
  const { compCdList, workPlaceList } = useCommonCodeStore();
  const [pickerVisible, setPickerVisible] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

  const handleOrderEmpFoucsId = "orderEmp_search";

  const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
    {
      fieldName: "orderEmp",
      category: "작업자",
      focusId: handleOrderEmpFoucsId,
      responseMapping: {
        empNo: "orderEmp",
        empNm: "orderEmpNm",
      },
      extraFilter: () => ({
        orderEmp: KSK2130_R01Filter.orderEmp || "",
        orderEmpNm: KSK2130_R01Filter.orderEmpNm || "",
      }),
    },
  ];

  const { getFieldHandlers } = useInfoFormEvents({
    editData: KSK2130_R01Filter,
    setEditData: setKSK2130_R01Filter,
    defaultData: defaultKSK2130_R01Filter,
    infoFieldConfigs,
    setCodeSearchModalProps,
    formName: "KSK2130_R01_search",
  });

  return (
    <SearchSectionDoubleForm>
      <SearchDropDownForm
        label="사업장"
        value={KSK2130_R01Filter.compCd}
        onChangeItem={(item) =>
          setKSK2130_R01Filter({ compCd: item?.compCd || "" })
        }
        optionList={compCdList}
      />
      <SearchDateRangeForm
        label="생산일자"
        visible={pickerVisible}
        setVisible={setPickerVisible}
        dateRange={KSK2130_R01Filter.dateRange}
        setDateRange={(dateRange) =>
          setKSK2130_R01Filter({ dateRange })
        }
        pickerPosition={pickerPosition}
        setPickerPosition={setPickerPosition}
      />
      <SearchDropDownForm
        label="작업공정"
        value={KSK2130_R01Filter.workplaceCd}
        onChangeItem={(item) =>
          setKSK2130_R01Filter({ workplaceCd: item?.workplaceCd || "" })
        }
        optionList={workPlaceList.filter(
          (item) => item.compCd === KSK2130_R01Filter.compCd,
        )}
        editable={KSK2130_R01Filter.compCd !== ""}
      />
      <SearchCodeModalForm
        label="작업자"
        value={KSK2130_R01Filter.orderEmp}
        valueLabel={KSK2130_R01Filter.orderEmpNm}
        handleFoucsId={handleOrderEmpFoucsId}
        onChange={getFieldHandlers("orderEmp").onChange}
        onDoubleClick={getFieldHandlers("orderEmp").onDoubleClick}
        onKeyDown={getFieldHandlers("orderEmp").onEnterKeyDown}
        wrapperOption={{
          wrapperStyle: "w-[350px] min-w-[350px] mr-[10px]",
          titleStyle: "w-[70px] min-w-[70px] text-left",
          codeInputStyle: "w-[190px] min-w-[190px]",
          nameTagStyle: "w-[170px] min-w-[170px] text-left",
        }}
      />
    </SearchSectionDoubleForm>
  );
};
